import {getWordBreakClassName} from 'lib/stringHelper';
import PropTypes from 'prop-types';

function TaskTransferDescription({labwareName, wellGroup, asDestination}) {
  return (
    <>
      &nbsp;
      <span>{asDestination ? 'to' : 'from'}</span>
      &nbsp;
      <span className={`green ${getWordBreakClassName(labwareName, 19)}`}>{labwareName}</span>
      &nbsp;
      <span>Well(s)</span>
      &nbsp;
      <span className="green">{`[${wellGroup}]`}</span>
    </>
  );
}

TaskTransferDescription.propTypes = {
  labwareName: PropTypes.string,
  wellGroup: PropTypes.string,
  asDestination: PropTypes.bool,
};

TaskTransferDescription.defaultProps = {
  wellGroup: '',
  labwareName: '',
  asDestination: false,
};

export default TaskTransferDescription;
